import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Proofcard } from "../models/proofcard_model";
import * as FileSaver from "file-saver";

@Injectable()
export class OpProofcardService {
  private baseUrl = "http://example.com/api/";
  constructor(private http: HttpClient) { }

  setHeader() {
    let headers = new HttpHeaders();
    return headers;
  }
  myHeaders = this.setHeader();

  deleteproofcard(bodyParams: Proofcard) {
    let url = environment.URL + "/proofcard/delete/" + bodyParams.id;
    return this.http.get(url, { headers: this.myHeaders });
  }

  tableSearch(value, column, pageId, jobId) {
    let url =
      environment.URL +
      "/proofcard/" +
      value +
      "/" +
      column +
      "/" +
      jobId +
      "?page=" +
      pageId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  sendProofcard(proofcardId, email) {
    let url = environment.URL + "/proofcardSend/" + proofcardId + "/" + email;
    return this.http.get(url, { headers: this.myHeaders });
  }

  downloadProofcard(proofcardId) {
    let url = environment.URL + "/proofcardDownload/" + proofcardId;
    // let downloadUrl = url;
    // var downloadFrame = document.createElement("iframe");
    // downloadFrame.setAttribute("src", downloadUrl);
    // downloadFrame.setAttribute("class", "screenReaderText");
    // document.body.appendChild(downloadFrame);
    // return this.http.get(url, { headers: this.myHeaders });

    this.http.get(url, { responseType: "arraybuffer" }).subscribe((res: any) => {
      const blob = new Blob([res], { type: "application/octet-stream" });
      FileSaver.saveAs(blob, "OlivePortraits.zip");
    });

  }

  getPdf(proofcardId) {
    let url = environment.URL + "/proofcardPDFShow/" + proofcardId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  getProofcardDetail(proofcardId) {
    let url = environment.URL + "/proofcardData/" + proofcardId;
    return this.http.get(url, { headers: this.myHeaders });
  }
  downloadJob(jobID) {
    let url = environment.URL + "/jobDownload/" + jobID;
    let downloadUrl = url;
    // var downloadFrame = document.createElement("iframe");
    // downloadFrame.setAttribute("src", downloadUrl);
    // downloadFrame.setAttribute("class", "screenReaderText");
    // document.body.appendChild(downloadFrame);
    // return this.http.get(url, { headers: this.myHeaders });
    this.http.get(url, { responseType: "arraybuffer" }).subscribe((res: any) => {
      const blob = new Blob([res], { type: "application/octet-stream" });
      FileSaver.saveAs(blob, "OlivePortraits.zip");
    });
  }

  // deleteProofcardZIPOnceDownloaded(jobID) {
  //   let url = environment.URL + "/proofcardDelete/" + jobID;
  //   return this.http.get(url, { headers: this.myHeaders });
  // }

  NurseryManagerViewer(jobID, className) {
    let url = environment.URL + "/proofcardViewer/" + jobID + "/" + className;
    return this.http.get(url, { headers: this.myHeaders });
  }

  gdprTable(value, column, pageId, filter) {
    let url =
      environment.URL +
      "/gdprTable/" +
      value +
      "/" +
      column +
      "/" +
      filter +
      "?page=" +
      pageId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  removeProofcardByGdpr(formData) {
    let url = environment.URL + "/proofcard/gdprDeleteFolderAdmin";
    return this.http.post(url, formData);
  }

  updateStudentName(proofcardId, name) {
    let url =
      environment.URL +
      "/proofcard/updateStudentName/" +
      proofcardId +
      "/" +
      name;
    return this.http.get(url, { headers: this.myHeaders });
  }

  export(jobId) {
    let url = environment.URL + "/proofcard/excelExport/" + jobId;
    // let downloadUrl = url;
    // var downloadFrame = document.createElement("iframe");
    // downloadFrame.setAttribute("src", downloadUrl);
    // downloadFrame.setAttribute("class", "screenReaderText");
    // document.body.appendChild(downloadFrame);
    this.http.get(url, { responseType: "arraybuffer" }).subscribe((res: any) => {
      const blob = new Blob([res], {
        type: "application/octet-stream",
      });
      FileSaver.saveAs(blob,  "OlivePortraits.csv");
    });


  }

  import(formData: FormData) {
    let url = environment.URL + "/proofcard/excelImport";
    return this.http.post(url, formData, { headers: this.myHeaders });
  }

  getClassNames(jobId) {
    let url = environment.URL + "/proofcard/getClassName/" + jobId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  QR(qrData) {
    let url = environment.URL + "/proofcard/qrCodes";
    return this.http.post(url, qrData, { headers: this.myHeaders });
  }
  importStudent(Studendate) {
    let url = environment.URL + "/proofcard/studentCSV";
    return this.http.post(url, Studendate, { headers: this.myHeaders });
  }

  importSiblingStudent(StudentData) {
    let url = environment.URL + "/proofcard/siblingStudentCSV";
    return this.http.post(url, StudentData, { headers: this.myHeaders });
  }

  getAllQrcodeshistory() {
    let url = environment.URL + "/qrcodeshistory/getAll";
    return this.http.get(url, { headers: this.myHeaders });
  }

  getAllQrcodeshistoryjobId(jobId) {
    let url = environment.URL + "/qrcodeshistory/proofcards/" + jobId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  // notifyEmail(bodyParams: Proofcard ) {
  //   let url = environment.URL + "/proofcard/customerEmailAdd";
  //   return this.http.post(url, bodyParams ,{ headers: this.myHeaders });
  // }

  notifyEmail(bodyParams) {
    let url = environment.URL + "/proofcard/customerEmailAdd";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  DownloadProofcardAll(qrcodeId) {
    let url = environment.URL + "/proofcardDownloadAll/" + qrcodeId;
    return this.http.get(url, {
      headers: this.myHeaders,
      responseType: "arraybuffer",
    });
  }

  DownloadQrCodeAll(qrcodeId: any) {
    let url = environment.URL + "/qrCodeDownloadAll/" + qrcodeId;
    return this.http.get(url, {
      headers: this.myHeaders,
      responseType: "arraybuffer",
    });
  }

  DeleteFileById(qrcodeId) {
    let url = environment.URL + "/proofcard/deleteAll/" + qrcodeId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  // exportstudent(jobId) {
  //   let url = environment.URL + "/studentExportTextFile/" + jobId;
  //   let downloadUrl = url;
  //   var downloadFrame = document.createElement("iframe");
  //   downloadFrame.setAttribute("src", downloadUrl);
  //   downloadFrame.setAttribute("class", "screenReaderText");
  //   document.body.appendChild(downloadFrame);
  // }
  exportstudent(jobId) {
    let url = environment.URL + "/proofcard/studentExportTextFile/" + jobId;
    return this.http.get(url, {
      headers: this.myHeaders,
      responseType: "arraybuffer",
      reportProgress: true,
    });
  }

  getAllJobWithSiteNameDropdown()
  {
    let url = environment.URL + "/proofcard/getAllJobWithSiteNameDropdown";

    return this.http.get(url, { headers: this.myHeaders });
  }

  generateQrCodes(count: number) {
    let url = environment.URL + "/proofcard/generateQrCodes";

    return this.http.post(url, {
      qr_codes_count: count,
    }, { headers: this.myHeaders, responseType: "arraybuffer", });
  }

  locateQrCode(accessCode: string) {
    let url = environment.URL + "/proofcard/locateAccessCode";

    return this.http.post(url, {access_code: accessCode}, { headers: this.myHeaders });
  }

  uploadZipFile(formData: any) {
    let url = environment.URL + "/proofcard/upload-zip";

    return this.http.post(url, formData, { headers: this.myHeaders, reportProgress: true, observe: 'events' });
  }

  getAwsUploadLogs(jobId: any) {
    let url = environment.URL + "/proofcard/get-aws-log/" + jobId;

    return this.http.get(url, { headers: this.myHeaders });
  }

  removeAwsUploadLogImage(logId: any, imageName: string) {
    let url = environment.URL + "/proofcard/aws-log-remove-image/" + logId + '/' + btoa(imageName) + '/delete';

    return this.http.get(url, { headers: this.myHeaders });
  }

  awsPublishImages(logId: any) {
    let url = environment.URL + "/proofcard/aws-log-image-publish/" + logId;

    return this.http.get(url, { headers: this.myHeaders });
  }
 }
